import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 -960 960 960"

const ArrowForwardIosIcon = createSvgIcon(
  <>
    <path d='m288-96-68-68 316-316-316-316 68-68 384 384L288-96Z' />
  </>,
  'ArrowForwardIosIcon'
)

export default ArrowForwardIosIcon
